export function getValue(name) {
    //If the name is indexed, then the element should get a specific name for this to work
    var element = $(':input[name="' + name + '"]');
    if (element.length == 0 && $(':input[name$="].' + name + '"]').length == 0) {
        element = $(':input[name$=".' + name + '"]');
    }
    var type = element.attr("type");
    return "checkbox" === type ? element.prop("checked").toString() : "radio" === type ? element.filter(":checked").val() : element.val()
}

export function parseValue(value, parseData) {
    if (void 0 === value)
        return null;
    switch (parseData.type) {
        case "System.String":
            return null == value ? "" : value.toString();
        case "System.Integer":
        case "System.Int32":
            var regexInt = /^\s*[-\+]?\d+\s*$/;
            if (null == value.match(regexInt))
                return null;
            var result = parseInt(value, 10);
            return isNaN(result) ? null : result;
        case "System.Double":
            var otherChar = parseData.decimalchar === ',' ? '\\.' : ',';

            // Build a regex that matches only the intended decimal character
            // and ignores the other one
            var regexDouble = new RegExp(
                "^\\s*([-\\+])?(\\d*)"
                + (parseData.decimalchar ? "\\" + parseData.decimalchar : "")
                + "?(\\d*)\\s*$"
            );

            // Remove any unintended decimal characters before matching
            var sanitizedValue = value.replace(new RegExp(otherChar, 'g'), '');

            result = sanitizedValue.match(regexDouble);
            if (null == result)
                return null;
            if (0 == result[2].length && 0 == result[3].length)
                return null;
            var s = (null != result[1] ? result[1] : "") + (result[2].length > 0 ? result[2] : "0") + (result[3].length > 0 ? "." + result[3] : ""),
                n = parseFloat(s);
            return isNaN(n) ? null : n;
        case "System.DateTime":
        case "System.DateOnly":
            const date = parseDate(value);
            return date ? date.valueOf() : null;
        case "System.Boolean":
            return null == value ? null : (value = value.toString().toLowerCase(), "true" === value || "false" === value ? value : null)
    }
    return null
}

export function parseDate(value) {
    var normalizedValue = value?.toString().trim().replace(/\./g, "-");
    var regexDate = /^(\d{2})-(\d{2})-(\d{4})$/;
    var match = normalizedValue.match(regexDate);

    if (null == match)
        return null;

    var day = parseInt(match[1], 10);
    var month = parseInt(match[2], 10);
    var year = parseInt(match[3], 10);

    var date = new Date(year, month - 1, day);

    if (date.getFullYear() !== year || date.getMonth() !== month - 1 || date.getDate() !== day)
        return null;

    return date;
}

export function compareValue(valuetocompare, operator, expectedvalue, type, params) {
    var parseData = {
        type: type,
        dateformat: params.dateformat,
        decimalchar: params.decimalchar
    };
    valuetocompare = parseValue(valuetocompare, parseData);
    expectedvalue = parseValue(expectedvalue, parseData);
    switch (operator) {
        case "NotEqual":
            return valuetocompare != expectedvalue;
        case "GreaterThan":
            return valuetocompare > expectedvalue;
        case "GreaterThanEqual":
            return valuetocompare >= expectedvalue;
        case "LessThan":
            return valuetocompare < expectedvalue;
        case "LessThanEqual":
            return valuetocompare <= expectedvalue;
        default:
            return valuetocompare == expectedvalue;
    }
}